import React, { useState } from 'react';
import { ShieldAlert, ChevronRight, X } from 'lucide-react';

const VerificationBanner = ({ stepState, phoneVerified, onStartVerification }) => {
    const [dismissed, setDismissed] = useState(false);

    if (!stepState || stepState === 'complete') return null;
    // Cubre usuarios con step_state desfasado en Firestore: si el teléfono ya
    // está verificado (OTP validado en landing o aquí), no pedimos verificar
    // de nuevo aunque el state siga en pending_verification_phone.
    if (stepState === 'pending_verification_phone' && phoneVerified === true) return null;
    if (dismissed) return null;

    const message =
        stepState === 'pending_verification_email'
            ? 'Verifica tu correo electrónico para completar tu cuenta.'
            : stepState === 'pending_verification_phone'
                ? 'Verifica tu número de teléfono para completar tu cuenta.'
                : 'Completa la verificación de tu cuenta.';

    return (
        <div className="flex items-center justify-between bg-amber-pill/30 rounded-card-md px-4 py-3 mb-4 text-sm">
            <div className="flex items-center gap-2.5 text-amber-deep">
                <ShieldAlert size={16} className="flex-shrink-0" />
                <span className="font-medium">{message}</span>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0 ml-3">
                <button
                    onClick={onStartVerification}
                    className="inline-flex items-center gap-1 text-amber-deep hover:text-ink font-bold text-sm transition-colors"
                >
                    Verificar
                    <ChevronRight size={14} />
                </button>
                <button
                    onClick={() => setDismissed(true)}
                    className="text-amber-deep/55 hover:text-amber-deep transition-colors p-0.5"
                    aria-label="Cerrar"
                >
                    <X size={14} />
                </button>
            </div>
        </div>
    );
};

export default VerificationBanner;
